import './StarIcon.scss';
import { ISVGIconProps } from './types';

interface IStarProps extends ISVGIconProps {
  half?: boolean;
}

export default function StarIcon({ half, className, height, width }: Readonly<IStarProps>) {
  const mask = half ? 'half' : 'full';
  const customClass = className ? ` ${className}` : '';
  const iconHeight = height ?? 32;
  const iconWidth = width ?? 32;
  return (
    <svg
      className={`nn-star${customClass}`}
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="half" maskUnits="userSpaceOnUse" x="0" y="0" width="50" height="100">
        <rect y="0" width="100" height="100" fill="#C4C4C4" />
      </mask>
      <mask id="full" maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
        <rect y="0" width="100" height="100" fill="#C4C4C4" />
      </mask>
      <path
        d="M50 0L61.2257 34.5491H97.5528L68.1636 55.9017L79.3893 90.4509L50 69.0983L20.6107 90.4509L31.8364 55.9017L2.44717 34.5491H38.7743L50 0Z"
        fill="#C4C4C4"
        fillOpacity="0.5"
      />
      <g mask={`url(#${mask})`}>
        <path
          d="M50 0L61.2257 34.5491H97.5528L68.1636 55.9017L79.3893 90.4509L50 69.0983L20.6107 90.4509L31.8364 55.9017L2.44717 34.5491H38.7743L50 0Z"
          fill="#F2C94C"
        />
      </g>
    </svg>
  );
}
